import type { IAuthor, IListResponse } from '@xbl/types'
import { request } from '@umijs/max'

/** 获取作者详情 GET /backend/author/:id */
export async function authorDetail(options?: Record<string, any>) {
  return request<{
    data: IAuthor
  }>('/backend/author/:id', {
    method: 'GET',
    ...options
  })
}

/** 获取是否有重名 GET /backend/author/getName */
export async function authorName(
  params: {
    title: string
    id?: number
  },
  options?: Record<string, any>
) {
  return request<{
    data: IAuthor
  }>('/backend/author/getName', {
    method: 'GET',
    params,
    ...options
  })
}

/** 添加作者 POST /backend/author/add */
export async function authorAdd(body: IAuthor, options?: Record<string, any>) {
  return request<{ data: IAuthor, status: number, message: string }>('/backend/author/add', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 更新作者 POST /backend/author/edit */
export async function authorEdit(body: IAuthor, options?: Record<string, any>) {
  return request<{ data: IAuthor, status: number, message: string }>(`/backend/author/${body.id}`, {
    method: 'PUT',
    data: body,
    ...options
  })
}

/** 删除作者 POST /backend/author/delete */
export async function authorDelete(body: { id?: number }, options?: Record<string, any>) {
  return request<{ data: IAuthor, status: number, message: string }>('/backend/author/delete', {
    method: 'DELETE',
    data: body,
    ...options
  })
}

/** 获取作者列表 GET /backend/author/list */
export async function authorList(
  params: {
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
    [key: string]: any
  },
  options?: Record<string, any>
) {
  return request<IListResponse<IAuthor>>('/backend/author/list', {
    method: 'GET',
    params: {
      ...params
    },
    ...options
  })
}
